import { pick } from 'lodash'
import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { IRateTypeKeyTypes } from 'types/graphqlTypes'
import { getRateTypeLabel } from '../../utils'

export enum AwardedLaneModalTab {
  Data = 'Data',
  LaneDetails = 'Lane Details',
  Notes = 'Notes',
  Rates = 'Rates',
}

export const selectableRateTypeKeys = Object.values(
  pick(IRateTypeKeyTypes, [
    'rfp_lane_carrier_line_haul_rpm',
    'rfp_lane_carrier_line_haul_flat',
    'rfp_lane_carrier_all_in',
  ])
)

export const rateTypeKeySelectOptions: TSelectOpt[] = selectableRateTypeKeys.map(rateTypeKey => ({
  label: getRateTypeLabel(rateTypeKey) ?? rateTypeKey,
  value: rateTypeKey,
}))
